import { useState, useEffect } from 'react';
import * as mapbox from 'mapbox-gl';

export const usePopup = (container: HTMLElement, size: number) => {
    const [popup, setPopup] = useState<mapbox.Popup>();

    useEffect(() => {
        if (container.innerHTML) {
            const createPopup = () => {
                const p = new mapbox.Popup({
                    offset: size,
                });

                p.setHTML(container.innerHTML);

                return p;
            };

            setPopup(createPopup());
        }
    }, [container, size]);

    return popup;
};
